import React from "react";
import { Modal } from "react-bootstrap";

import { getWelcomeLogo } from '../../utils/brandingConfig';

import '../Hub/styles/index.css'
const bg1 = "https://d9apl513jlx0u.cloudfront.net/public_assets/src/images_new/Banner1.png";

// Other UI (e.g. the domain migration banner) reads this class to hide itself
// while the age-confirm dialog covers the screen.
const AGE_CONFIRM_BODY_CLASS = "age-confirm-modal-open";

const Welcome = ({ fullScreen, showLogin, processed }) => {
  const [open, setOpen] = React.useState(true);

  React.useLayoutEffect(() => {
    document.body.classList.toggle(AGE_CONFIRM_BODY_CLASS, open);
    return () => document.body.classList.remove(AGE_CONFIRM_BODY_CLASS);
  }, [open]);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <main>
        <Modal size="sm" show={open} className="unlock verify dark" centered>
          <Modal.Body className="age-confirm-body">
            <h1>Warning !</h1>
            <p className = "mb-0">Are you 18 or older?</p>
          </Modal.Body>
          <Modal.Footer className="modal-footer">
            <div className="w-100 h-100 d-flex">
              <div className="d-flex w-50 justify-content-center">
                <button
                  id="accept_age"
                  className="w-100 button-footer border-right"
                  onClick={showLogin}
                >
                  <div>
                    {processed && <div className="btn-spinner" />}
                  </div>
                  Yes, I am
                </button>
              </div>
              <div className="d-flex w-50 h-100 justify-content-center">
                <button
                  id="decline_age"
                  onClick={handleClose}
                  className="w-100 button-footer border-left"
                >
                  No, I am not
                </button>
              </div>
            </div>
          </Modal.Footer>
        </Modal>
      </main>
      <div
        id="carouselExampleIndicators"
        className="carousel slide carousel-fade"
        data-bs-ride="carousel"
        data-bs-interval="2000"
        data-bs-touch="true"
      >
        <div className="carousel-indicators">
          <button
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide-to={0}
            className="active"
            aria-current="true"
            aria-label="Slide 1"
          />
        </div>
        <div className="carousel-inner">
          <div className="carousel-item active">
            <img
              src={bg1}
              className="d-block w-100 img-fluid"
              alt={bg1}
              style={{ height: "100vh" }}
            />
          </div>
          <div className="overlay-box">
            <div style={{ zIndex: 99 }}>
              <div className="img">
                <img src={getWelcomeLogo()} className="img-fluid" alt="logo" />
              </div>
              <div className="text text-center">
                <h3>
                  A <span>PLACE</span> WHERE YOU CAN <br />
                  CREATE YOUR OWN <span>WORLD</span>
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Welcome;
